module.exports = "<my-axletrees-edit-form my-axletrees=\"$$axletree.data.myAxletrees\"\n  my-wagon-id=\"$$wagon.local.getCurrentScrappedId()\"\n  default-weight=\"$$sale.data.mySale.axletreeDefaultWeight\">\n</my-axletrees-edit-form>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/scrapping/sale/templates/editAxletrees.html
// module id = 1623
// module chunks = 0